module.exports = "/desktop-app/assets/img/bell.svg?cdae2eb5cf251630fe43f910c7fe8653";


//////////////////
// WEBPACK FOOTER
// ./foody/src/assets/common/svg/bell.svg
// module id = htVY
// module chunks = 1